import { cloneDeep } from "lodash";
import React, { useState } from "react";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import numberFormat from "../../common/numberFormat";
import api from "../../config/api";
import colors from "../../config/colors";
import config from "../../config/config";
import moment from "moment";
import { MdMenu } from "react-icons/md";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
const size = config.iconSize;

export default function EditSalaryModel() {
  const [disabled, setDisabled] = useState(false);
  const queryClient = useQueryClient();

  const Body = ({ employee, onDone, data }) => {
    const [form, setForm] = useState(
      cloneDeep({
        ...data,
        amount: Number(data.amount),
        date: moment(data.date, "DD/MM/YYYY").toDate(),
      })
    );
    console.log(data.date);
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
    };
    const handleSubmit = async (event) => {
      event.preventDefault();

      setDisabled(true);
      const res = await api.put("salary", {
        ...form,
        employee,
      });
      if (!res.ok) {
        setDisabled(false);
        toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["salary"]);

      setForm({});
      setDisabled(false);
      toast.success("Salary has been successfully paid.");

      onDone && onDone();
    };
    return (
      <form id="form" onSubmit={handleSubmit}>
        <div
          className="d-flex"
          style={{ gap: "0px 30px", padding: "0px 30px" }}
        >
          <AppInput
            type="date"
            name="date"
            placeholder="Date"
            label="Date"
            floatLabel
            value={form.date}
            mask="99/99/9999"
            slotChar="DD/MM/YYYY"
            onChange={handleChange}
            required
          />

          <AppInput
            name="amount"
            value={numberFormat(form.amount)}
            onChange={handleChange}
            required
            label="Amount"
            floatLabel
          />
          <AppInput
            name="comment"
            value={form.comment}
            onChange={handleChange}
            required
            label="Comment"
            floatLabel
          />
        </div>
      </form>
    );
  };
  const Header = ({ employee }) => {
    return (
      <span className="d-flex" style={{ alignItems: "center" }}>
        <MdMenu size={size} color={colors.silver} style={{ marginRight: 5 }} />
        <b>Pay Salary - {employee.name}</b>
      </span>
    );
  };
  const Footer = () => {
    return (
      <AppButton
        disabled={disabled}
        text="Save"
        form="form"
        type="submit"
        className="text-primary btn-light"
      />
    );
  };

  return { Header, Footer, Body };
}
